/**
 * 专题 接口的统一出口
 */
 import axios from "../http"; // 导入http中创建的axios实例
 import qs from "qs"; // 根据需求是否导入qs模块，把请求字段直接映射过来
 const api = "";
 const index = {
	// 专题详情
	detail(params) {
		return axios.get("/home/zhuanti", { params: params });
	},
	// 评论列表
	commentlist(params){
		return axios.get("/home/zhuanti/commentlist", { params: params });
	},
	// 添加评论
	createcomment(params){
		return axios.post('/home/zhuanticomment/create', qs.stringify(params))
	}
 };
 // 导出接口
export default index;